'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('../../typography/ErrorText/ErrorText.js');
require('../../typography/LargeDarkText/LargeDarkText.js');
require('../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../typography/MediumDarkText/MediumDarkText.js');
require('../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../typography/MediumText/MediumText.js');
require('../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../../typography/SmallDarkText/SmallDarkText.js');
require('../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../typography/SmallLinkText/SmallLinkText.js');
var SmallTitleText = require('../../typography/SmallTitleText/SmallTitleText.js');
require('../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../typography/TinyDarkText/TinyDarkText.js');
require('../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../typography/TinyLinkText/TinyLinkText.js');
require('../../typography/TinyTitleText/TinyTitleText.js');
require('../../typography/XXLargeDarkText/XXLargeDarkText.js');
var RadioGroup = _interopDefault(require('@material-ui/core/RadioGroup'));
var Radio = _interopDefault(require('@material-ui/core/Radio'));
var FormControlLabel = _interopDefault(require('@material-ui/core/FormControlLabel'));
var styledComponents = require('./styled-components.js');

var RadioButtonGroup = function (props) {
    var reportChange = props.reportChange, id = props.id, label = props.label, _a = props.row, row = _a === void 0 ? false : _a, radioButtons = props.radioButtons, groupName = props.groupName, selected = props.selected;
    var _b = React.useState(selected), value = _b[0], setValue = _b[1];
    React.useEffect(function () {
        setValue(selected);
    }, [selected]);
    var handleChange = function (event) {
        setValue(event.target.value);
        reportChange(event.target.value);
    };
    return (React__default.createElement(React__default.Fragment, null,
        label && typeof label === 'string' && (React__default.createElement(styledComponents.Label, { htmlFor: id, "data-testid": 'label' },
            React__default.createElement(SmallTitleText, null, label))),
        label && typeof label !== 'string' && label,
        React__default.createElement(RadioGroup, { style: { flexDirection: row ? 'row' : 'column' }, id: id, "aria-label": groupName, name: groupName, value: value, onChange: handleChange }, radioButtons.map(function (radioButton) { return (React__default.createElement(FormControlLabel, { key: radioButton.label, value: radioButton.value, control: React__default.createElement(Radio, { color: 'primary' }), label: radioButton.label, disabled: !!radioButton.disabled })); }))));
};

module.exports = RadioButtonGroup;
